<template>
  <v-dialog
    :value="value"
    max-width="600"
    overlay-color="var(--ds-color-reverse)"
    @input="closeDialog"
  >
    <v-card>
      <v-card-title>
        <template v-if="count > 1">
          {{ $t('components.RemoveCardModal.label.title.removeCards', {count: count}) }}
        </template>

        <template v-else>
          {{ $t('components.RemoveCardModal.label.title.removeCard', {count: count}) }}
        </template>
      </v-card-title>

      <v-card-actions class="ds-padding-stack--xs">
        <v-spacer />
        <DsButton
          color="secondary"
          @click="closeDialog"
        >
          {{ $t('components.RemoveCardModal.label.button.cancel') }}
        </DsButton>
        <DsButton
          class="ds-margin-left-stack--xs"
          @click="continueRemoveCard"
        >
          {{ $t('components.RemoveCardModal.label.button.remove') }}
        </DsButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DsButton } from '@ds/components';
import { MUTATE } from '@/store/modules/mutation_types';
import { mapMutations } from 'vuex';

export default {
  name: 'RemoveCardModal',
  components: {
    DsButton,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
      require: true,
    },
  },
  methods: {
    ...mapMutations('misc', {
      mutateMisc: MUTATE,
    }),
    closeDialog() {
      this.$emit('input', false);
      this.mutateMisc({
        property: 'showConfig',
        with: true,
      });
    },
    continueRemoveCard() {
      this.$emit('enableSharing');
      this.$emit('input', false);
      this.mutateMisc({
        property: 'showConfig',
        with: true,
      });
    },
  },
};
</script>
